import { useParams } from "react-router-dom";

import { useAuth } from "../../../context/AuthProvider";
import Wrapper from "../../../shared/components/layout/Wrapper";
import StatusMessage from "../../../shared/components/elements/StatusMessage";

import CourseSections from "../components/CourseSections";
import LearnHeader from "../components/LearnHeader";
import LearnLayout from "../components/LearnLayout";
import { useCourseStructure } from "../hooks/useCourseStructure";
import { LEARN_MESSAGES } from "../messages";

const CourseStructurePage = () => {
    const { course_id: courseId } = useParams<{ course_id: string }>();
    const { user } = useAuth();
    const { data: course, loading, error } = useCourseStructure(courseId);

    const renderContent = () => {
        if (loading) return <StatusMessage>{LEARN_MESSAGES.loading}</StatusMessage>;

        if (error || !course || !courseId) {
            return (
                <p role="alert" className="py-8 text-center text-red-500">
                    {error?.message || LEARN_MESSAGES.failed}
                </p>
            );
        }

        return (
            <CourseSections
                courseId={courseId}
                sections={course.sections ?? []}
                rules={{
                    hasBought: course.has_bought,
                    paidLevels: course.paid_levels,
                    currentLevel: course.course_level
                }}
            />
        );
    };

    return (
        <LearnLayout
            header={
                <LearnHeader
                    userId={user?.id}
                    courseId={courseId}
                    title={course?.title}
                    xp={user?.xp}
                    credit={user?.credit}
                    streak={user?.streak}
                    showPurchaseButton={!!course && !course.has_bought}
                />
            }
        >
            <Wrapper>{renderContent()}</Wrapper>
        </LearnLayout>
    );
};

export default CourseStructurePage;